"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Generalist = void 0;
const Resources_1 = require("../Resources");
class Generalist {
    constructor() {
        this.name = 'Generalist';
        this.description = 'Have increased all 6 productions by at least 1 step';
    }
    getScore(player) {
        let score = 0;
        const requiredProduction = player.game.gameOptions.corporateEra ? 0 : 1;
        if (player.getProduction(Resources_1.Resources.MEGACREDITS) > requiredProduction)
            score++;
        if (player.getProduction(Resources_1.Resources.STEEL) > requiredProduction)
            score++;
        if (player.getProduction(Resources_1.Resources.TITANIUM) > requiredProduction)
            score++;
        if (player.getProduction(Resources_1.Resources.PLANTS) > requiredProduction)
            score++;
        if (player.getProduction(Resources_1.Resources.ENERGY) > requiredProduction)
            score++;
        if (player.getProduction(Resources_1.Resources.HEAT) > requiredProduction)
            score++;
        return score;
    }
    canClaim(player) {
        return this.getScore(player) === 6;
    }
}
exports.Generalist = Generalist;
//# sourceMappingURL=Generalist.js.map